export default __webpack_public_path__ + "static/media/left_leaf.6c21b080.png";